import treesStep1 from '~/assets/steps/1.png'
import treesStep2 from '~/assets/steps/2.png'
import treesStep3 from '~/assets/steps/3.png'
import treesStep4 from '~/assets/steps/4.png'
import { LeafIcon } from '~/components/icon/leaf'
import { cn } from '~/lib/utils'
import { m } from '~/paraglide/messages'
import { getCheckpoints } from './config'

const treeImages: Record<number, string> = {
  1: treesStep1,
  2: treesStep2,
  3: treesStep3,
  4: treesStep4,
}

type Props = {
  checkpoint: number
  currentEnergy: number
}

export function Milestone(props: Props) {
  const checkpoint = () => getCheckpoints()[props.checkpoint]

  const status = () => {
    const { energyAmount } = checkpoint()
    if (props.currentEnergy >= energyAmount) return 'completed'
    const prevEnergy =
      props.checkpoint > 1
        ? getCheckpoints()[props.checkpoint - 1].energyAmount
        : 0
    if (props.currentEnergy < prevEnergy) return 'inactive'
    return 'current'
  }

  const isInactive = () => status() === 'inactive'
  const isLastCompleted = () =>
    props.checkpoint === 4 && status() === 'completed'

  return (
    <div class="flex w-[116px] shrink-0 flex-col items-center gap-2">
      {/* Energy label */}
      <span
        class={cn(
          'font-rubik text-sm font-bold leading-[20px] text-white',
          isInactive() && 'opacity-30',
          isLastCompleted() && 'invisible',
        )}
      >
        {checkpoint().energyAmount / 1000}K
      </span>

      {/* Milestone dot */}
      <div
        class={cn(
          'relative z-10 size-[26px] overflow-hidden rounded-full',
          isInactive()
            ? 'bg-[#037067] text-[#025A53]'
            : 'bg-[#e6fffd] text-[#037067]',
        )}
        style={
          isLastCompleted()
            ? {
                background:
                  'radial-gradient(circle at 50% 0%, #FFF 0%, #FEFFCE 50%, #FDFF9C 100%)',
                'box-shadow':
                  '0 -2px 0 0 rgba(0, 0, 0, 0.17) inset, 0 -6px 17.6px 0 rgba(245, 255, 109, 0.81)',
                outline: '3px solid #DDC211',
              }
            : undefined
        }
      >
        <LeafIcon />
      </div>

      {/* Tree cluster image */}
      <div
        class={cn(
          'flex h-[66px] w-full items-center justify-center',
          isInactive() && 'opacity-30',
        )}
      >
        <img
          src={treeImages[props.checkpoint]}
          class="max-h-full max-w-full object-contain"
        />
      </div>

      {/* Tree count text */}
      <div
        class={cn(
          'flex flex-col items-center gap-1 whitespace-nowrap text-center',
          isInactive() && 'opacity-30',
        )}
      >
        <div class="flex items-center gap-1">
          <span
            class="font-rubik text-[24px] font-bold leading-none text-[#1B472B]"
            style={{
              '-webkit-text-stroke':
                '5px ' + (isLastCompleted() ? '#FFF4A2' : 'white'),
              'paint-order': 'stroke fill',
            }}
          >
            {checkpoint().treeCount.toLocaleString()}
          </span>
          <span class="text-xs text-white">{m.unit_for_tree()}</span>
        </div>
      </div>
    </div>
  )
}
